import { SessionAuthorityTypes } from '@as-react/common-types';
export const isLoggedInUser = (userSession) => {
    var _a;
    return ((_a = userSession === null || userSession === void 0 ? void 0 : userSession.authorities) === null || _a === void 0 ? void 0 : _a.length)
        ? userSession.authorities[0] && userSession.authorities[0].authority !== SessionAuthorityTypes.ANONYMOUS
        : false;
};
export const isLoggedInGuestWebReturns = (userSession) => {
    var _a, _b, _c;
    return ((_a = userSession === null || userSession === void 0 ? void 0 : userSession.authorities) === null || _a === void 0 ? void 0 : _a.length)
        ? ((_b = userSession.authorities[0]) === null || _b === void 0 ? void 0 : _b.authority) === SessionAuthorityTypes.ANONYMOUS &&
            ((_c = userSession.authorities[1]) === null || _c === void 0 ? void 0 : _c.authority) === SessionAuthorityTypes.GUEST_WEB_RETURNS
        : false;
};
